import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import StarIcon from '../../../../assets/icons/StarIcon';
import { colorsPalette } from '../../../../theme';
import useStyles from './styles';

interface StarsPanelProps {
  wrapperClass?: string;
  iconClass?: string;
  filledStars: number;
  maxStars?: number;
}

const StarsPanel: React.FC<StarsPanelProps> = ({
  wrapperClass,
  iconClass,
  filledStars,
  maxStars = 3,
}) => {
  const classes = useStyles();

  const filledStarsCount = maxStars > filledStars ? filledStars : maxStars;
  const outlinedStarsCount = maxStars - filledStarsCount;

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      {Array.from(Array(filledStarsCount)).map((x, index) => (
        <StarIcon
          data-testid="filledStar"
          key={`f${index}`}
          className={cx(classes.icon, classes.filledIcon, iconClass)}
          color={colorsPalette.white}
        />
      ))}
      {Array.from(Array(outlinedStarsCount)).map((x, index) => (
        <StarIcon key={index} className={cx(classes.icon, iconClass)} color={colorsPalette.white} />
      ))}
    </Box>
  );
};

export default StarsPanel;
